/* src/app/components/elibraryandcourse/e-library/e-library-details/e-library-details.component.scss */
.document-workspace {
  --primary: #253b80;
  --primary-dark: #1d2f6f;
  --primary-soft: #eef2ff;
  --text-primary: #172033;
  --text-secondary: #64748b;
  --text-muted: #94a3b8;
  --border: #e2e6ef;
  --surface: #ffffff;
  --surface-soft: #f7f9fc;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--surface-soft);
  color: var(--text-primary);
  overflow: hidden;
}
.document-header {
  min-height: 72px;
  display: flex;
  align-items: center;
  padding: 10px 18px;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid var(--border);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.03);
  position: relative;
  z-index: 10;
  gap: 18px;
}
.document-header__left {
  min-width: 220px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}
.document-info {
  min-width: 0;
}
.document-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}
.document-title {
  margin: 0;
  max-width: 260px;
  color: var(--text-primary);
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.document-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 20px;
  background: #f0fdf4;
  color: #15803d;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}
.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.1);
}
.document-updated {
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: var(--text-muted);
  font-size: 11px;
}
.document-updated i {
  font-size: 10px;
}
.icon-btn {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.icon-btn:hover {
  background: var(--primary-soft);
  border-color: #c7d2fe;
  color: var(--primary);
  transform: translateY(-1px);
}
.icon-btn i {
  font-size: 14px;
}
.document-ai-actions {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
}
.workspace-action {
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 11px;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: #fff;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.workspace-action:hover {
  border-color: #c7d2fe;
  background: var(--primary-soft);
  color: var(--primary);
  transform: translateY(-1px);
}
.workspace-action.icon-only {
  width: 36px;
  padding: 0;
}
.workspace-action.ai-action {
  border-color: #e0e7ff;
  background: #eef2ff;
  color: #253B80;
}
.workspace-action.ai-action:hover {
  border-color: #c7d2fe;
  background:
    linear-gradient(
      135deg,
      #eef2ff,
      #ede9fe);
}
.workspace-action.ai-action img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
.document-header__right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.ai-label-mobile {
  display: none;
}
@media (max-width: 767px) {
  .ai-label-desktop {
    display: none;
  }
  .ai-label-mobile {
    display: inline;
  }
}
.document-search {
  width: 220px;
  height: 38px;
  position: relative;
  display: flex;
  align-items: center;
}
.document-search input {
  width: 100%;
  height: 100%;
  padding: 0 36px 0 37px;
  border: 1px solid var(--border);
  border-radius: 10px;
  outline: none;
  background: #f8fafc;
  color: var(--text-primary);
  font-size: 12px;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}
.document-search input::placeholder {
  color: #a1a9b8;
}
.document-search input:focus {
  background: #fff;
  border-color: #a5b4fc;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.08);
}
.search-icon {
  position: absolute;
  left: 13px;
  color: #94a3b8;
  font-size: 13px;
  z-index: 1;
}
.search-clear {
  position: absolute;
  right: 7px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
}
.search-clear:hover {
  background: #f1f5f9;
  color: #475569;
}
.view-switcher {
  height: 38px;
  display: flex;
  align-items: center;
  padding: 3px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: #f8fafc;
}
.view-switcher button {
  height: 30px;
  min-width: 34px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.view-switcher button:hover {
  color: #475569;
}
.view-switcher button.active {
  background: #fff;
  color: var(--primary);
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.08);
}
.view-switcher button i {
  font-size: 13px;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 7px;
}
.upload-button {
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  border: 0;
  border-radius: 9px;
  background: #253B80;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 4px 10px rgba(99, 102, 241, 0.18);
  cursor: pointer;
  transition: all 0.2s ease;
}
.upload-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 7px 16px rgba(99, 102, 241, 0.25);
}
.upload-button i {
  font-size: 13px;
}
.close-workspace {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}
.close-workspace:hover {
  background: #fef2f2;
  border-color: #fecaca;
  color: #dc2626;
}
.document-content {
  min-height: 0;
  flex: 1;
  overflow: hidden;
  background:
    linear-gradient(
      180deg,
      #f8fafc 0%,
      #f5f7fb 100%);
}
.document-scroll {
  height: calc(100vh - 80px);
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 4px 8px 20px 0;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.document-scroll::-webkit-scrollbar {
  width: 7px;
}
.document-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.document-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.document-scroll::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.document-view {
  width: 100%;
}
.document-dashboard {
  width: 100%;
}
.upload-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.48);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  animation: overlay-in 0.2s ease-out;
}
.upload-dialog {
  width: min(1100px, 100%);
  max-height: calc(100vh - 48px);
  flex-direction: column;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 25px 70px rgba(15, 23, 42, 0.2);
  animation: dialog-in 0.25s ease-out;
}
.upload-dialog__header {
  min-height: 82px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border);
  background:
    linear-gradient(
      135deg,
      #ffffff,
      #fafaff);
}
.upload-dialog__identity {
  display: flex;
  align-items: center;
  gap: 13px;
  min-width: 0;
}
.upload-dialog__icon {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: var(--primary-soft);
  color: var(--primary);
  box-shadow: inset 0 0 0 1px rgba(99, 102, 241, 0.08);
}
.upload-dialog__icon i {
  font-size: 19px;
}
.upload-dialog__eyebrow {
  display: block;
  margin-bottom: 3px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}
.upload-dialog__title {
  margin: 0;
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.upload-dialog__description {
  max-width: 600px;
  margin: 3px 0 0;
  color: var(--text-secondary);
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.upload-dialog__close {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s ease;
}
.upload-dialog__close:hover {
  background: #fef2f2;
  color: #dc2626;
}
.upload-dialog__body {
  min-height: 0;
  flex: 1;
  overflow-y: auto;
  background: #f8fafc;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.upload-dialog__body::-webkit-scrollbar {
  width: 6px;
}
.upload-dialog__body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
[data-tooltip] {
  position: relative;
}
[data-tooltip]::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  padding: 6px 9px;
  border-radius: 6px;
  background: #172033;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s ease, transform 0.15s ease;
  z-index: 9999;
}
[data-tooltip]:hover::after {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}
@keyframes overlay-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes dialog-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 1200px) {
  .document-header {
    gap: 10px;
    padding: 10px 14px;
  }
  .document-search {
    width: 180px;
  }
  .workspace-action.ai-action span {
    display: none;
  }
  .workspace-action.ai-action {
    width: 36px;
    padding: 0;
  }
}
@media (max-width: 992px) {
  .document-header {
    flex-wrap: wrap;
    min-height: auto;
    padding: 10px 12px;
  }
  .document-header__left {
    flex: 1;
  }
  .document-ai-actions {
    order: 3;
    width: 100%;
    padding-top: 4px;
  }
  .document-header__right {
    margin-left: auto;
  }
  .document-search {
    width: 170px;
  }
  .document-scroll {
    padding: 15px;
  }
}
@media (max-width: 767px) {
  .document-header {
    align-items: flex-start;
    padding: 10px;
    height: 24vh;
  }
  .document-header__left {
    min-width: 0;
  }
  .document-info {
    max-width: calc(100vw - 65px);
  }
  .document-title {
    max-width: 170px;
    font-size: 14px;
  }
  .document-status {
    display: none;
  }
  .document-header__right {
    width: 100%;
    margin-left: 0;
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 8px;
  }
  .document-search {
    width: 100%;
  }
  .view-switcher button span {
    display: none;
  }
  .view-switcher button {
    width: 32px;
    padding: 0;
  }
  .header-actions {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .upload-button {
    width: 38px;
    padding: 0;
  }
  .upload-button span {
    display: none;
  }
  .close-workspace {
    width: 34px;
    height: 34px;
  }
  .document-ai-actions {
    overflow-x: auto;
    padding-bottom: 2px;
    scrollbar-width: none;
  }
  .document-ai-actions::-webkit-scrollbar {
    display: none;
  }
  .workspace-action {
    flex-shrink: 0;
  }
  .workspace-action.ai-action span {
    display: inline;
  }
  .workspace-action.ai-action {
    width: auto;
    padding: 0 10px;
  }
  .upload-overlay {
    padding: 0;
    align-items: flex-end;
  }
  .upload-dialog {
    width: 100%;
    max-height: 94vh;
    border-radius: 18px 18px 0 0;
  }
  .upload-dialog__header {
    min-height: 72px;
    padding: 13px 15px;
  }
  .upload-dialog__body {
    padding: 14px;
  }
  .upload-dialog__description {
    max-width: 240px;
  }
  .document-scroll {
    padding: 12px;
  }
}
@media (max-width: 480px) {
  .document-title {
    max-width: 145px;
  }
  .document-updated {
    font-size: 10px;
  }
  .sidebar-toggle {
    width: 34px;
    height: 34px;
    flex-basis: 34px;
  }
  .document-ai-actions {
    gap: 5px;
  }
  .workspace-action {
    height: 34px;
    font-size: 11px;
  }
  .workspace-action.ai-action img {
    width: 16px;
    height: 16px;
  }
  .document-search {
    height: 36px;
  }
  .view-switcher {
    height: 36px;
  }
}
.edit-document-overlay {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.58);
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  animation: modalOverlayIn 0.2s ease-out;
}
.edit-document-modal {
  width: min(920px, 100%);
  max-height: min(900px, 100vh - 48px);
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.18), 0 8px 24px rgba(15, 23, 42, 0.08);
  animation: modalSlideIn 0.25s ease-out;
}
.edit-modal-header {
  min-height: 82px;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e8edf3;
  background: #ffffff;
}
.header-content {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}
.header-icon {
  width: 46px;
  height: 46px;
  flex: 0 0 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  background:
    linear-gradient(
      135deg,
      #eef4ff,
      #e8f0ff);
  color: #356ae6;
  font-size: 20px;
}
.header-content h3 {
  margin: 0;
  color: #172033;
  font-size: 19px;
  font-weight: 700;
  line-height: 1.3;
}
.header-content p {
  margin: 4px 0 0;
  color: #7b8798;
  font-size: 13px;
  line-height: 1.4;
}
.modal-close-btn {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 10px;
  background: #f5f7fa;
  color: #687386;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}
.modal-close-btn i {
  font-size: 15px;
}
.modal-close-btn:hover {
  background: #feeceb;
  color: #dc3545;
  transform: rotate(90deg);
}
.modal-close-btn:focus-visible {
  outline: 3px solid rgba(53, 106, 230, 0.18);
}
.edit-modal-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px;
  background: #f8fafc;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.edit-modal-body::-webkit-scrollbar {
  width: 6px;
}
.edit-modal-body::-webkit-scrollbar-track {
  background: transparent;
}
.edit-modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.form-section {
  padding: 22px;
  margin-bottom: 18px;
  background: #ffffff;
  border: 1px solid #e7ebf1;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.025);
}
.form-section:last-child {
  margin-bottom: 0;
}
.section-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 22px;
}
.section-icon {
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f0f5ff;
  color: #356ae6;
}
.section-icon i {
  font-size: 16px;
}
.section-heading h4 {
  margin: 0;
  color: #202b3c;
  font-size: 15px;
  font-weight: 700;
}
.section-heading p {
  margin: 3px 0 0;
  color: #8994a5;
  font-size: 12px;
}
.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}
.form-field {
  min-width: 0;
}
.form-field.full-width {
  grid-column: 1/-1;
}
.form-field label {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 7px;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
}
.required {
  color: #e5484d;
  font-size: 13px;
}
.optional {
  margin-left: 3px;
  color: #98a2b3;
  font-size: 11px;
  font-weight: 400;
}
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.input-wrapper i {
  position: absolute;
  left: 14px;
  z-index: 1;
  color: #98a2b3;
  font-size: 14px;
  pointer-events: none;
}
.input-wrapper input {
  width: 100%;
  height: 44px;
  padding: 0 14px 0 40px;
  border: 1px solid #dce2ea;
  border-radius: 10px;
  background: #ffffff;
  color: #202b3c;
  font-size: 13px;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}
.input-wrapper input::placeholder {
  color: #a5afbd;
}
.input-wrapper input:hover {
  border-color: #c6ceda;
}
.input-wrapper input:focus {
  border-color: #5b7fe8;
  box-shadow: 0 0 0 3px rgba(91, 127, 232, 0.11);
}
.form-field textarea {
  width: 100%;
  min-height: 105px;
  padding: 12px 14px;
  resize: vertical;
  border: 1px solid #dce2ea;
  border-radius: 10px;
  background: #ffffff;
  color: #202b3c;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.5;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.form-field textarea::placeholder {
  color: #a5afbd;
}
.form-field textarea:hover {
  border-color: #c6ceda;
}
.form-field textarea:focus {
  border-color: #5b7fe8;
  box-shadow: 0 0 0 3px rgba(91, 127, 232, 0.11);
}
.select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.select-wrapper > i:first-child {
  position: absolute;
  left: 14px;
  z-index: 1;
  color: #98a2b3;
  font-size: 14px;
  pointer-events: none;
}
.select-wrapper select {
  width: 100%;
  height: 44px;
  appearance: none;
  -webkit-appearance: none;
  padding: 0 40px;
  border: 1px solid #dce2ea;
  border-radius: 10px;
  background: #ffffff;
  color: #344054;
  font-size: 13px;
  outline: none;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.select-wrapper select:focus {
  border-color: #5b7fe8;
  box-shadow: 0 0 0 3px rgba(91, 127, 232, 0.11);
}
.select-wrapper .select-arrow {
  position: absolute;
  right: 14px;
  color: #8a94a6;
  font-size: 11px;
  pointer-events: none;
}
.users-section {
  padding-bottom: 16px;
}
.users-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.section-heading-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.add-user-button {
  height: 36px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 13px;
  border: 1px solid #d8e2fb;
  border-radius: 9px;
  background: #f4f7ff;
  color: #356ae6;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.add-user-button i {
  font-size: 13px;
}
.add-user-button:hover:not(:disabled) {
  background: #eaf0ff;
  border-color: #c8d7fa;
  transform: translateY(-1px);
}
.add-user-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.selected-users-info {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 12px;
  padding: 10px 12px;
  border: 1px solid #d9f0e3;
  border-radius: 9px;
  background: #f1fbf5;
  color: #397455;
  font-size: 12px;
}
.selected-users-info strong {
  color: #216b47;
  font-weight: 700;
}
.selected-info-icon {
  width: 23px;
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #d9f4e4;
  color: #2e8b57;
}
.selected-info-icon i {
  font-size: 11px;
}
.users-list {
  max-height: 275px;
  overflow-y: auto;
  padding: 2px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.users-list::-webkit-scrollbar {
  width: 5px;
}
.users-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.user-row {
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 9px 10px;
  border-bottom: 1px solid #edf0f4;
  transition: background 0.18s ease;
}
.user-row:last-child {
  border-bottom: 0;
}
.user-row:hover {
  background: #f8fafc;
  border-radius: 9px;
}
.user-profile {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 11px;
}
.user-avatar {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #eef2f7;
  color: #667085;
}
.user-avatar i {
  font-size: 15px;
}
.user-details {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.user-name {
  max-width: 450px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
}
.admin-badge {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 7px;
  border-radius: 20px;
  background: #fff6df;
  color: #a56b00;
  font-size: 10px;
  font-weight: 600;
}
.admin-badge i {
  font-size: 9px;
}
.remove-user-btn {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #98a2b3;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.remove-user-btn i {
  font-size: 13px;
}
.remove-user-btn:hover {
  background: #fff0f0;
  color: #dc3545;
}
.empty-users {
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 25px 15px;
  text-align: center;
  border: 1px dashed #dce2ea;
  border-radius: 12px;
  background: #fafbfc;
}
.empty-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 9px;
  border-radius: 12px;
  background: #eef2f6;
  color: #98a2b3;
}
.empty-icon i {
  font-size: 18px;
}
.empty-users h5 {
  margin: 0 0 4px;
  color: #475467;
  font-size: 13px;
  font-weight: 700;
}
.empty-users p {
  max-width: 300px;
  margin: 0;
  color: #98a2b3;
  font-size: 11px;
}
.edit-modal-footer {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 24px;
  border-top: 1px solid #e8edf3;
  background: #ffffff;
}
.cancel-button {
  height: 40px;
  padding: 0 18px;
  border: 1px solid #dce2ea;
  border-radius: 9px;
  background: #ffffff;
  color: #475467;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.cancel-button:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}
.update-button {
  min-width: 160px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 18px;
  border: 0;
  border-radius: 9px;
  background:
    linear-gradient(
      135deg,
      #356ae6,
      #4c7cf0);
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 5px 12px rgba(53, 106, 230, 0.18);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
}
.update-button i {
  font-size: 12px;
}
.update-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 7px 16px rgba(53, 106, 230, 0.24);
}
.update-button:active:not(:disabled) {
  transform: translateY(0);
}
.update-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}
.form-field form-validation {
  display: block;
  margin-top: 5px;
}
@media (max-width: 768px) {
  .edit-document-overlay {
    padding: 14px;
  }
  .edit-document-modal {
    max-height: calc(100vh - 28px);
    border-radius: 16px;
  }
  .edit-modal-header {
    padding: 16px 18px;
  }
  .edit-modal-body {
    padding: 16px;
  }
  .form-section {
    padding: 18px;
  }
  .form-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .form-field.full-width {
    grid-column: auto;
  }
  .users-heading {
    align-items: flex-start;
    gap: 12px;
  }
  .add-user-button {
    flex-shrink: 0;
  }
  .edit-modal-footer {
    padding: 12px 18px;
  }
}
@media (max-width: 576px) {
  .edit-document-overlay {
    align-items: flex-end;
    padding: 0;
  }
  .edit-document-modal {
    width: 100%;
    max-height: 94vh;
    border-radius: 18px 18px 0 0;
    animation: modalMobileIn 0.25s ease-out;
  }
  .edit-modal-header {
    min-height: 70px;
    padding: 14px 16px;
  }
  .header-icon {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    border-radius: 10px;
    font-size: 17px;
  }
  .header-content {
    gap: 10px;
  }
  .header-content h3 {
    font-size: 16px;
  }
  .header-content p {
    display: none;
  }
  .modal-close-btn {
    width: 34px;
    height: 34px;
    flex-basis: 34px;
  }
  .edit-modal-body {
    padding: 12px;
  }
  .form-section {
    padding: 15px;
    margin-bottom: 12px;
    border-radius: 13px;
  }
  .section-heading {
    margin-bottom: 17px;
  }
  .section-heading h4 {
    font-size: 14px;
  }
  .section-heading p {
    font-size: 12px;
  }
  .section-icon {
    width: 34px;
    height: 34px;
    flex-basis: 34px;
    border-radius: 9px;
  }
  .users-heading {
    flex-direction: column;
    align-items: stretch;
  }
  .section-heading-left {
    width: 100%;
  }
  .add-user-button {
    width: 100%;
    justify-content: center;
  }
  .user-name {
    max-width: 200px;
  }
  .edit-modal-footer {
    min-height: auto;
    padding: 12px;
    display: grid;
    grid-template-columns: 1fr 1.5fr;
  }
  .cancel-button,
  .update-button {
    width: 100%;
    min-width: 0;
  }
}
@media (max-width: 380px) {
  .edit-document-modal {
    max-height: 96vh;
  }
  .edit-modal-body {
    padding: 9px;
  }
  .form-section {
    padding: 13px;
  }
  .user-avatar {
    width: 32px;
    height: 32px;
    flex-basis: 32px;
  }
  .user-name {
    max-width: 165px;
    font-size: 14px;
  }
  .update-button {
    padding: 0 10px;
  }
}
@keyframes modalOverlayIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes modalMobileIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.e-library-modal .modal-background {
  background: rgba(15, 23, 42, 0.58);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
.e-library-modal .upload-modal-card {
  width: min(620px, 100% - 32px);
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  margin: auto;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e5eaf0;
  border-radius: 20px;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.18), 0 8px 25px rgba(15, 23, 42, 0.08);
  animation: uploadModalIn 0.25s ease-out;
}
.upload-modal-header {
  min-height: 82px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 22px;
  background: #fff;
  border-bottom: 1px solid #e9edf2;
}
.upload-header-content {
  display: flex;
  align-items: center;
  gap: 13px;
}
.upload-header-icon {
  width: 45px;
  height: 45px;
  flex: 0 0 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  background:
    linear-gradient(
      135deg,
      #edf4ff,
      #e5eeff);
  color: #356ae6;
}
.upload-header-icon i {
  font-size: 20px;
}
.upload-header-content h3 {
  margin: 0;
  color: #172033;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}
.upload-header-content p {
  margin: 4px 0 0;
  color: #8792a4;
  font-size: 12px;
}
.upload-close-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 9px;
  background: #f5f7fa;
  color: #697586;
  cursor: pointer;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}
.upload-close-btn i {
  font-size: 14px;
}
.upload-close-btn:hover {
  background: #feecec;
  color: #dc3545;
  transform: rotate(90deg);
}
.upload-close-btn:focus-visible {
  outline: 3px solid rgba(53, 106, 230, 0.15);
}
.upload-modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  background: #f8fafc;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.upload-modal-body::-webkit-scrollbar {
  width: 5px;
}
.upload-modal-body::-webkit-scrollbar-track {
  background: transparent;
}
.upload-modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.upload-label,
.form-label {
  display: block;
  margin-bottom: 8px;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
}
.required {
  color: #e5484d;
  margin-left: 2px;
}
.upload-field {
  margin-bottom: 22px;
}
.modern-upload-box {
  position: relative;
  min-height: 245px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border: 1.5px dashed #cbd6e5;
  border-radius: 15px;
  background:
    linear-gradient(
      180deg,
      #fbfdff 0%,
      #f7faff 100%);
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease;
}
.modern-upload-box:hover {
  border-color: #7b9bea;
  background:
    linear-gradient(
      180deg,
      #fafdff 0%,
      #f3f7ff 100%);
}
.modern-upload-box.has-file {
  min-height: auto;
  padding: 15px;
  border-style: solid;
  border-color: #d7e1ef;
  background: #fff;
}
.upload-empty {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
}
.upload-cloud-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  border-radius: 16px;
  background: #edf4ff;
  color: #4d78df;
  box-shadow: 0 5px 15px rgba(53, 106, 230, 0.08);
}
.upload-cloud-icon i {
  font-size: 27px;
}
.upload-main-text {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.upload-main-text strong {
  color: #263348;
  font-size: 14px;
  font-weight: 700;
}
.upload-main-text span {
  color: #8a95a5;
  font-size: 11px;
}
.browse-file-btn {
  height: 36px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 15px;
  padding: 0 14px;
  border: 1px solid #d4def2;
  border-radius: 9px;
  background: #f5f8ff;
  color: #356ae6;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.browse-file-btn i {
  font-size: 13px;
}
.browse-file-btn:hover {
  background: #eaf0ff;
  border-color: #bdcdef;
  transform: translateY(-1px);
}
.supported-files {
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 17px;
}
.supported-files span {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  color: #7d899a;
  font-size: 10px;
  font-weight: 600;
}
.supported-files span i {
  font-size: 10px;
}
.supported-files small {
  color: #a0a9b6;
  font-size: 9px;
  line-height: 1.5;
}
.selected-file-card {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px;
  border: 1px solid #e0e7f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.04);
}
.selected-file-icon {
  width: 45px;
  height: 45px;
  flex: 0 0 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f2f5f9;
}
.selected-file-icon img {
  object-fit: contain;
}
.selected-file-info {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.selected-file-label {
  color: #98a2b3;
  font-size: 10px;
  font-weight: 500;
}
.selected-file-name {
  overflow: hidden;
  color: #344054;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.remove-file-btn {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: #fff1f1;
  color: #dc3545;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}
.remove-file-btn i {
  font-size: 13px;
}
.remove-file-btn:hover {
  background: #ffe2e2;
  transform: scale(1.05);
}
.change-file-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 11px auto 2px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #4b73d8;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.change-file-btn:hover {
  color: #2858c8;
  text-decoration: underline;
}
.change-file-btn i {
  font-size: 11px;
}
.form-field {
  margin-bottom: 0;
}
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.input-wrapper i {
  position: absolute;
  left: 14px;
  color: #98a2b3;
  font-size: 14px;
  pointer-events: none;
}
.form-input {
  width: 100%;
  height: 44px;
  padding: 0 14px 0 40px;
  border: 1px solid #d8e0ea;
  border-radius: 10px;
  outline: none;
  background: #fff;
  color: #344054;
  font-size: 13px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.form-input::placeholder {
  color: #a4adba;
}
.form-input:hover {
  border-color: #c6cfdb;
}
.form-input:focus {
  border-color: #5b7fe8;
  box-shadow: 0 0 0 3px rgba(91, 127, 232, 0.11);
}
.upload-modal-footer {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 22px;
  border-top: 1px solid #e8edf3;
  background: #fff;
}
.cancel-upload-btn {
  height: 40px;
  padding: 0 18px;
  border: 1px solid #dce2ea;
  border-radius: 9px;
  background: #fff;
  color: #475467;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}
.cancel-upload-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}
.confirm-upload-btn {
  min-width: 125px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 17px;
  border: 0;
  border-radius: 9px;
  background:
    linear-gradient(
      135deg,
      #356ae6,
      #4d7df0);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 5px 13px rgba(53, 106, 230, 0.18);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    opacity 0.2s ease;
}
.confirm-upload-btn i {
  font-size: 13px;
}
.confirm-upload-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 7px 17px rgba(53, 106, 230, 0.24);
}
.confirm-upload-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}
.loading-btn {
  cursor: wait;
  opacity: 0.8;
}
@media (max-width: 768px) {
  .e-library-modal .upload-modal-card {
    width: min(580px, 100% - 28px);
  }
  .e-library-modal .upload-modal-body {
    padding: 20px;
  }
}
@media (max-width: 576px) {
  .e-library-modal .upload-modal-card {
    width: 100%;
    max-height: 94vh;
    border-radius: 18px 18px 0 0;
    animation: uploadModalMobileIn 0.25s ease-out;
  }
  .e-library-modal .upload-modal-header {
    min-height: 70px;
    padding: 14px 16px;
  }
  .e-library-modal .upload-header-icon {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    border-radius: 10px;
  }
  .e-library-modal .upload-header-icon i {
    font-size: 17px;
  }
  .e-library-modal .upload-header-content h3 {
    font-size: 16px;
  }
  .e-library-modal .upload-header-content p {
    display: none;
  }
  .e-library-modal .upload-close-btn {
    width: 34px;
    height: 34px;
  }
  .e-library-modal .upload-modal-body {
    padding: 15px;
  }
  .e-library-modal .modern-upload-box {
    min-height: 220px;
    padding: 15px;
  }
  .e-library-modal .upload-cloud-icon {
    width: 52px;
    height: 52px;
  }
  .e-library-modal .upload-cloud-icon i {
    font-size: 23px;
  }
  .e-library-modal .upload-main-text strong {
    font-size: 13px;
  }
  .e-library-modal .upload-main-text span {
    font-size: 10px;
  }
  .e-library-modal .supported-files {
    max-width: 280px;
  }
  .e-library-modal .upload-modal-footer {
    padding: 12px 15px;
    display: grid;
    grid-template-columns: 1fr 1.3fr;
  }
  .e-library-modal .cancel-upload-btn,
  .e-library-modal .confirm-upload-btn {
    width: 100%;
    min-width: 0;
  }
}
@media (max-width: 380px) {
  .e-library-modal .upload-modal-body {
    padding: 11px;
  }
  .e-library-modal .modern-upload-box {
    min-height: 205px;
  }
  .e-library-modal .upload-main-text span {
    display: none;
  }
  .e-library-modal .supported-files small {
    font-size: 8px;
  }
  .e-library-modal .selected-file-name {
    max-width: 180px;
  }
}
@keyframes uploadModalIn {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes uploadModalMobileIn {
  from {
    opacity: 0;
    transform: translateY(35px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.modalMobileView.more-user-modal {
  --modal-primary: #4f46e5;
  --modal-primary-dark: #4338ca;
  --modal-text: #172033;
  --modal-muted: #6b7280;
  --modal-border: #e5e7eb;
  --modal-bg: #f8fafc;
  --modal-white: #ffffff;
  --modal-success: #16a34a;
  position: fixed;
  inset: 0;
  z-index: 9999;
}
.modalMobileView.more-user-modal .modal-background {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  animation: modalFadeIn 0.2s ease;
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .modern-modal {
  position: relative;
  z-index: 2;
  width: min(520px, 100vw - 32px);
  max-height: min(720px, 100vh - 40px);
  margin: auto;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 20px;
  overflow: hidden;
  background: var(--modal-white);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18), 0 8px 24px rgba(15, 23, 42, 0.08);
  animation: modalSlideUp 0.25s ease;
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .modern-modal-head {
  min-height: 74px;
  padding: 18px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--modal-border);
  background: #fff;
}
.modalMobileView.more-user-modal .modern-modal-head .modal-title {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 11px;
  color: var(--modal-text);
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
}
.modalMobileView.more-user-modal .modern-modal-head .modal-title i {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  color: var(--modal-primary);
  background: #eef2ff;
  font-size: 17px;
}
.modalMobileView.more-user-modal .modern-modal-head .delete {
  width: 34px;
  height: 34px;
  min-width: 34px;
  margin: 0;
  border-radius: 10px;
  background: #f1f5f9;
  transition: background 0.2s ease, transform 0.2s ease;
}
.modalMobileView.more-user-modal .modern-modal-head .delete:hover {
  background: #fee2e2;
  transform: rotate(90deg);
}
.modalMobileView.more-user-modal .modern-modal-head .delete::before,
.modalMobileView.more-user-modal .modern-modal-head .delete::after {
  background-color: #64748b;
}
.modalMobileView.more-user-modal .modern-modal-head .delete:hover::before,
.modalMobileView.more-user-modal .modern-modal-head .delete:hover::after {
  background-color: #dc2626;
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .modern-modal-body {
  flex: 1;
  min-height: 0;
  padding: 20px;
  overflow: hidden;
  background: var(--modal-bg);
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .search-container {
  margin-bottom: 14px;
}
.modalMobileView.more-user-modal .search-container .control {
  position: relative;
}
.modalMobileView.more-user-modal .search-container .search-input {
  width: 100%;
  height: 44px;
  padding-left: 43px;
  padding-right: 40px;
  border: 1px solid #dbe1ea;
  border-radius: 11px;
  background: #fff;
  color: var(--modal-text);
  font-size: 14px;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.03);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.modalMobileView.more-user-modal .search-container .search-input::placeholder {
  color: #9ca3af;
}
.modalMobileView.more-user-modal .search-container .search-input:focus {
  border-color: var(--modal-primary);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  outline: none;
}
.modalMobileView.more-user-modal .search-container .icon.is-left {
  left: 13px;
  top: 50%;
  width: 20px;
  height: 20px;
  transform: translateY(-50%);
  color: #94a3b8;
}
.modalMobileView.more-user-modal .search-container .icon.is-left i {
  font-size: 15px;
}
.modalMobileView.more-user-modal .search-container .clear-icon {
  right: 10px;
  top: 50%;
  width: 28px;
  height: 28px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #94a3b8;
  border-radius: 7px;
  transition: color 0.2s ease, background 0.2s ease;
}
.modalMobileView.more-user-modal .search-container .clear-icon:hover {
  color: #ef4444;
  background: #fef2f2;
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .select-all-container {
  margin-bottom: 10px;
}
.modalMobileView.more-user-modal .select-all-item {
  min-height: 52px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--modal-border);
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    transform 0.15s ease;
}
.modalMobileView.more-user-modal .select-all-item:hover {
  border-color: #c7d2fe;
  background: #fafbff;
}
.modalMobileView.more-user-modal .select-all-item:active {
  transform: scale(0.99);
}
.modalMobileView.more-user-modal .select-all-item.active {
  border-color: #c7d2fe;
  background: #eef2ff;
}
.modalMobileView.more-user-modal .select-all-item.active .user-avatar {
  color: var(--modal-primary);
  background: #e0e7ff;
}
.modalMobileView.more-user-modal .select-all-item.active .user-name {
  color: var(--modal-primary);
  font-weight: 700;
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .user-avatar {
  width: 36px;
  height: 36px;
  min-width: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: #64748b;
  background: #f1f5f9;
  transition: color 0.2s ease, background 0.2s ease;
}
.modalMobileView.more-user-modal .user-avatar i {
  font-size: 15px;
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .user-name {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .check-icon {
  margin-left: auto;
  color: var(--modal-primary);
  font-size: 18px;
  animation: checkScale 0.18s ease;
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .user-list {
  height: calc(100% - 120px);
  min-height: 180px;
  padding: 2px 3px 10px 1px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.modalMobileView.more-user-modal .user-list::-webkit-scrollbar {
  width: 6px;
}
.modalMobileView.more-user-modal .user-list::-webkit-scrollbar-track {
  background: transparent;
}
.modalMobileView.more-user-modal .user-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.modalMobileView.more-user-modal .user-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .user-item {
  min-height: 56px;
  margin-bottom: 6px;
  padding: 9px 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.15s ease;
}
.modalMobileView.more-user-modal .user-item:hover {
  border-color: #e2e8f0;
  background: #f8fafc;
}
.modalMobileView.more-user-modal .user-item:active {
  transform: scale(0.99);
}
.modalMobileView.more-user-modal .user-item.active {
  border-color: #c7d2fe;
  background: #eef2ff;
}
.modalMobileView.more-user-modal .user-item.active .user-avatar {
  color: var(--modal-primary);
  background: #e0e7ff;
}
.modalMobileView.more-user-modal .user-item.active .user-name {
  color: #3730a3;
  font-weight: 700;
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .modern-modal-foot {
  min-height: 72px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid var(--modal-border);
  background: #fff;
}
.modalMobileView.more-user-modal .button-group {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.modalMobileView.more-user-modal {
}
.modalMobileView.more-user-modal .clear-btn,
.modalMobileView.more-user-modal .cancel-btn,
.modalMobileView.more-user-modal .add-btn,
.modalMobileView.more-user-modal .publish-btn {
  height: 40px;
  padding: 0 16px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.15s ease,
    box-shadow 0.2s ease;
}
.modalMobileView.more-user-modal .clear-btn i,
.modalMobileView.more-user-modal .cancel-btn i,
.modalMobileView.more-user-modal .add-btn i,
.modalMobileView.more-user-modal .publish-btn i {
  margin-right: 6px;
  font-size: 13px;
}
.modalMobileView.more-user-modal .clear-btn:active,
.modalMobileView.more-user-modal .cancel-btn:active,
.modalMobileView.more-user-modal .add-btn:active,
.modalMobileView.more-user-modal .publish-btn:active {
  transform: scale(0.97);
}
.modalMobileView.more-user-modal .clear-btn {
  border: 1px solid #e2e8f0;
  color: #64748b;
  background: #fff;
}
.modalMobileView.more-user-modal .clear-btn:hover {
  border-color: #cbd5e1;
  color: #334155;
  background: #f8fafc;
}
.modalMobileView.more-user-modal .cancel-btn {
  border: 1px solid #e2e8f0;
  color: #475569;
  background: #fff;
}
.modalMobileView.more-user-modal .cancel-btn:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}
.modalMobileView.more-user-modal .add-btn,
.modalMobileView.more-user-modal .publish-btn {
  border: 0;
  color: #fff;
  background:
    linear-gradient(
      135deg,
      var(--modal-primary),
      var(--primary));
  box-shadow: 0 5px 14px rgba(79, 70, 229, 0.22);
}
.modalMobileView.more-user-modal .add-btn:hover:not(:disabled),
.modalMobileView.more-user-modal .publish-btn:hover:not(:disabled) {
  background:
    linear-gradient(
      135deg,
      var(--modal-primary-dark),
      var(--modal-primary));
  box-shadow: 0 7px 18px rgba(79, 70, 229, 0.28);
}
.modalMobileView.more-user-modal .add-btn:disabled,
.modalMobileView.more-user-modal .publish-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}
.modalMobileView.more-user-modal .publish-btn {
  min-width: 100px;
}
.modalMobileView.more-user-modal {
}
@media (max-width: 576px) {
  .modalMobileView.more-user-modal .modern-modal {
    width: calc(100vw - 20px);
    max-height: calc(100vh - 20px);
    border-radius: 16px;
  }
  .modalMobileView.more-user-modal .modern-modal-head {
    min-height: 66px;
    padding: 14px 16px;
  }
  .modalMobileView.more-user-modal .modern-modal-head .modal-title {
    font-size: 16px;
  }
  .modalMobileView.more-user-modal .modern-modal-head .modal-title i {
    width: 34px;
    height: 34px;
    border-radius: 9px;
    font-size: 15px;
  }
  .modalMobileView.more-user-modal .modern-modal-body {
    padding: 14px;
  }
  .modalMobileView.more-user-modal .modern-modal-foot {
    padding: 12px 14px;
  }
  .modalMobileView.more-user-modal .clear-btn {
    padding: 0 12px;
  }
  .modalMobileView.more-user-modal .cancel-btn,
  .modalMobileView.more-user-modal .add-btn,
  .modalMobileView.more-user-modal .publish-btn {
    padding: 0 13px;
  }
  .modalMobileView.more-user-modal .user-item,
  .modalMobileView.more-user-modal .select-all-item {
    min-height: 52px;
  }
  .modalMobileView.more-user-modal .user-avatar {
    width: 34px;
    height: 34px;
    min-width: 34px;
  }
}
@media (max-width: 400px) {
  .modalMobileView.more-user-modal .modern-modal-foot {
    flex-wrap: wrap;
  }
  .modalMobileView.more-user-modal .clear-btn {
    order: 2;
  }
  .modalMobileView.more-user-modal .button-group {
    width: 100%;
    margin-left: 0;
  }
  .modalMobileView.more-user-modal .button-group .cancel-btn,
  .modalMobileView.more-user-modal .button-group .add-btn,
  .modalMobileView.more-user-modal .button-group .publish-btn {
    flex: 1;
  }
}
@keyframes modalFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes modalSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes checkScale {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
/*# sourceMappingURL=e-library-details.component.css.map */
